const theHtml = (stuff) => ({ __html: stuff })

export default theHtml;
